import { onClickOutside } from '@vueuse/core'

export function useProfileDropdown() {
  const { $device } = useNuxtApp()
  const isDropdownOpen = useState('dropdownOpen', () => false)
  const dropdownRef = ref<HTMLElement>()

  const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value
  }

  const closeDropdown = () => {
    isDropdownOpen.value = false
  }

  onClickOutside(dropdownRef, () => {
    if (!$device.isMobile && isDropdownOpen.value) {
      closeDropdown()
    }
  })

  return {
    isDropdownOpen,
    toggleDropdown,
    closeDropdown,
    dropdownRef,
  }
}
